import React from "react";
import cx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/pro-light-svg-icons/faAngleRight";
export var SubCategoryLink = function (_a) {
    var className = _a.className, url = _a.url, label = _a.label;
    return (React.createElement("a", { href: url, className: cx("uppercase text-primary-200", className) },
        React.createElement("span", { className: "inline-block mr-1" }, label),
        React.createElement(FontAwesomeIcon, { icon: faAngleRight, width: "5", height: "12" })));
};
//# sourceMappingURL=SubCategoryLink.js.map